import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Top',
    component: () => import('./components/Top.vue')
  },
  {
    path: '/users/:userId',
    name: 'User',
    component: () => import('./components/Top.vue')
  },
  {
    path: '/rooms/:roomId',
    name: 'Room',
    component: () => import('./components/Room.vue')
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('./components/Terms.vue')
  },
  {
    path: '/privacy_policy',
    name: 'PrivacyPolicy',
    component: () => import('./components/PrivacyPolicy.vue')
  }
]
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior () {
    return { left: 0, top: 0 }
  }
})

const setCanonical = () => {
  const link = document.querySelector('link[rel="canonical"]') || document.createElement('link')
  link.setAttribute('rel', 'canonical')
  link.setAttribute('href', window.location.href.replace('drawtalk2.laineus.com', 'drawtalk.laineus.com'))
  if (!document.head.contains(link)) {
    document.head.appendChild(link)
  }
}
setCanonical()
router.afterEach(() => setCanonical())

export default router
